/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

/**
 * @module bulb-block-alignment/bulbblockalignment
 */

import { Plugin } from 'ckeditor5';
import BulbBlockAlignmentEditing from './bulbblockalignmentediting';
import BulbBlockAlignmentUI from './bulbblockalignmentui';

/**
 * The block alignment plugin.
 *
 * @extends Plugin
 */
export default class BulbBlockAlignment extends Plugin {

  /**
   * @inheritDoc
   */
  public static get requires() {
    return [BulbBlockAlignmentEditing, BulbBlockAlignmentUI] as const;
  }

  /**
   * @inheritDoc
   */
  public static get pluginName() {
    return 'BulbBlockAlignment' as const;
  }
}
